module.exports = __webpack_public_path__ + "media/images/delivery-8d604a38b8a07632443112ca69f9a32f.svg";